import React, { useState, useEffect } from 'react';

function BookingModal({ isOpen, onClose, onConfirm, djs, date, locationId, initialEventName, editable }) {
    const [djId, setDjId] = useState('');
    const [startTime, setStartTime] = useState('10:00');
    const [endTime, setEndTime] = useState('11:00');

    if (!isOpen) return null;

    // Filter DJs by location if locationId is provided
    const filteredDjs = locationId
        ? djs.filter(dj => {
            if (!dj.locations || dj.locations.length === 0) return true; // show DJs with no location assignment
            return dj.locations.some(loc => loc.id === locationId);
        })
        : djs;

    const handleSubmit = () => {
        if (!djId || !startTime || !endTime) {
            alert("Please fill all fields.");
            return;
        }
        onConfirm({ dj_id: parseInt(djId), start_time: startTime, end_time: endTime });
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999  // ⬅️ This line ensures it stays on top
        }}>
            <div style={{
                backgroundColor: 'white', padding: 20, borderRadius: 8,
                minWidth: 300
            }}>
                <h3>Book DJ on {date}</h3>

                <br /><br />
                <label>DJ:
                    <select value={djId} onChange={e => setDjId(e.target.value)}>
                        <option value="">-- Select DJ --</option>
                        {filteredDjs.map(dj => (
                            <option key={dj.id} value={dj.id}>{dj.name}</option>
                        ))}
                    </select>
                </label>
                <br /><br />

                <label>Start Time:
                    <input type="time" value={startTime} onChange={e => setStartTime(e.target.value)} />
                </label>
                <br /><br />

                <label>End Time:
                    <input type="time" value={endTime} onChange={e => setEndTime(e.target.value)} />
                </label>
                <br /><br />

                <button onClick={handleSubmit}>Confirm</button>
                <button onClick={onClose} style={{ marginLeft: 10 }}>Cancel</button>
            </div>
        </div>
    );
}

export default BookingModal;
